class AWS {
  constructor() {}
}

export default new AWS();
